import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";

import "./ContentHeader.scss";
import { createDataAttributes } from "../../utilities";

const ContentHeader = ({ className, children, is360, dataAttrib, ...rest }) => {
  const classes = classnames("uikit__content-header", className, {
    "uikit__content-header__is360": is360
  });
  return (
    <div className={classes} {...createDataAttributes(dataAttrib)} {...rest}>
      <h1>{children}</h1>
    </div>
  );
};

ContentHeader.propTypes = {
  children: propTypes.oneOfType([
    propTypes.string,
    propTypes.element,
    propTypes.node
  ]).isRequired,
  className: propTypes.string,
  is360: propTypes.bool,
  dataAttrib: propTypes.arrayOf(Object)
};

ContentHeader.defaultProps = { is360: false };

export default ContentHeader;
